import { getAuthData } from "../../helpers/localStorageHelpers";
import { Api, HttpResponse } from "./apiSchema";
// import i18n from "i18next";

const customFetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const authToken = getAuthData()?.access_token;

    // let currentLocale = i18n.language;

    const headers = {
        ...init?.headers,
        Authorization: authToken ? `Bearer ${authToken}` : null,
        // "Accept-Language": currentLocale,
    };

    const response = await fetch(input,
        {
            ...init,
            headers: headers
        } as RequestInit
    );
    return response;
};


export const ENV_WEB_API_BASEPATH = "https://api.womapp.uk";

export const api = new Api({ baseUrl: ENV_WEB_API_BASEPATH, customFetch });

// TODO: Replace any with error view model
export const useApi = async <T>(request: () => Promise<HttpResponse<T, any>>) => {
    let isLoading = false;
    let result = null;
    let error = null;

    // TODO: Replace any with error view model
    let response: HttpResponse<T, any>;
    try {
        isLoading = true;
        response = await request();
        result = response.data;
        isLoading = false;
    } catch (err: any) {
        console.error("Error happened during web api request: ", err.error);
        console.log("HTTP Response code, ", err.status)
        error = err.error;
    }

    return {
        isLoading: isLoading,
        result: result,
        error: error,
    };
};